// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Main/style.css
 ** module id = 837
 ** module chunks = 0
 **/